import { EVENT_NAME, EVENT_TYPE } from '@cash-rewards/mparticlejs';
import { extractUtmQuery, useMparticle } from '@cash-rewards/reactjs';
import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';

export default function useReportRouteChangeEvent() {
  const { trackEvent } = useMparticle();
  const router = useRouter();
  const reportPageViewEvent = useCallback(() => {
    const utmQuery = extractUtmQuery(router.query);

    trackEvent(EVENT_NAME.page_view as EVENT_NAME, EVENT_TYPE.Navigation, {
      ...utmQuery,
    });
  }, [router.query, trackEvent]);

  useEffect(() => {
    const handleRouteChange = () => {
      reportPageViewEvent();
    };
    router.events.on('routeChangeComplete', handleRouteChange);
    router.events.on('hashChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
      router.events.off('hashChangeComplete', handleRouteChange);
    };
  }, [reportPageViewEvent, router]);

  useEffect(() => {
    reportPageViewEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
